import { render, staticRenderFns } from "./typeElSelect.vue?vue&type=template&id=e6035bd0"
import script from "./typeElSelect.vue?vue&type=script&lang=js"
export * from "./typeElSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports